import { Injectable } from "@angular/core";
@Injectable()
export class SessionHelper {
  static destroy() {
    localStorage.clear();
  }

  static setSession(user, token) {
    this.destroy();
    localStorage.setItem('currentUser', JSON.stringify(user));
    localStorage.setItem('token', token);
  }

  static setNewToken(token) {
    localStorage.setItem('token', token);
  }

  static setModules(modules) {
    localStorage.setItem('modules', JSON.stringify(modules));
  }

  static getSessionItem(item) {
    return localStorage.getItem(item);
  }

  static getUserId() {
    return JSON.parse(SessionHelper.getSessionItem('currentUser')).id;
  }

  static getUserRole() {
    return JSON.parse(SessionHelper.getSessionItem('currentUser')).role;
  }
  static getIsAdmin() {
    return JSON.parse(SessionHelper.getSessionItem('currentUser')).isAdmin;
  }

  static getModules() {
    return JSON.parse(SessionHelper.getSessionItem('modules'));
  }

  static getModuleCRUD(module) {
    let curd = {};
    SessionHelper.getModules().forEach((element) => {
      if (module.toLowerCase() === '/home/' + element.moduleName.toLowerCase()) {
        curd = {
          create: element.canCreate,
          delete: element.canDelete,
          update: element.canUpdate,
          read: element.canRead,
        };
      }
    });
    return curd;
  }
}
